import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Subject } from "rxjs";
import { filter, timeout } from "rxjs/operators";
var reportErrorInfREp = [/www\.gstatic\.com/];
var limitedAccessResult = {
  captcha_token: "Limited access"
};
export var ReCaptchaApi = /*#__PURE__*/function () {
  function ReCaptchaApi() {
    _classCallCheck(this, ReCaptchaApi);
    _defineProperty(this, "isiInitErrorLister", false);
    _defineProperty(this, "isScriptLoadError", false);
    _defineProperty(this, "_resolve", function (value) {});
    _defineProperty(this, "readyKeys", []);
    _defineProperty(this, "subject", new Subject());
  }
  _createClass(ReCaptchaApi, [{
    key: "catchError",
    value: function catchError() {
      var _this = this;
      if (this.isiInitErrorLister) {
        return;
      }
      window.addEventListener("error", function (event) {
        var _event$target, _event$target$tagName;
        var tagName = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$tagName = _event$target.tagName) === null || _event$target$tagName === void 0 ? void 0 : _event$target$tagName.toUpperCase();
        if (tagName === "SCRIPT") {
          var _event$target2;
          var _src = (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.src;
          if (reportErrorInfREp.some(function (v) {
            return v.test(_src);
          })) {
            var _reportInfoToSlack, _ref;
            _this.isScriptLoadError = true;
            _this._resolve(limitedAccessResult);
            (_reportInfoToSlack = (_ref = window).reportInfoToSlack) === null || _reportInfoToSlack === void 0 ? void 0 : _reportInfoToSlack.call(_ref, event);
          }
        }
      }, true);
      this.isiInitErrorLister = true;
    }
  }, {
    key: "loadScript",
    value: function loadScript(siteKey, lang, onload, onerror) {
      var _this2 = this;
      var scriptId = "re-captcha-".concat(siteKey);
      if (this.isScriptLoadError) {
        this.isScriptLoadError = false;
        var scr = document.getElementById(scriptId);
        if (scr) {
          var _scr$parentNode;
          (_scr$parentNode = scr.parentNode) === null || _scr$parentNode === void 0 ? void 0 : _scr$parentNode.removeChild(scr);
        }
        if (this.readyKeys.includes(siteKey)) {
          this.readyKeys.splice(this.readyKeys.indexOf(siteKey), 1);
        }
      }
      if (this.readyKeys.includes(siteKey)) {
        onload();
        return;
      }
      if (!document.getElementById(scriptId)) {
        var script = document.createElement("script");
        script.id = scriptId;
        script.type = "text/javascript";
        script.async = true;
        var loadTimeoutId = setTimeout(function () {
          script.onload = function () {};
          script.onerror = function () {};
          onerror();
        }, 3000);
        script.onload = function () {
          window.grecaptcha.enterprise.ready( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  clearTimeout(loadTimeoutId);
                  _this2.readyKeys.push(siteKey);
                  _this2.subject.next({
                    siteKey: siteKey
                  });
                  onload();
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          })));
        };
        script.onerror = function () {
          clearTimeout(loadTimeoutId);
          var scr = document.getElementById(scriptId);
          if (scr) {
            var _scr$parentNode2;
            (_scr$parentNode2 = scr.parentNode) === null || _scr$parentNode2 === void 0 ? void 0 : _scr$parentNode2.removeChild(scr);
          }
          onerror();
        };
        script.src = "https://www.recaptcha.net/recaptcha/enterprise.js?hl=".concat(lang, "&render=").concat(siteKey);
        var head = document.getElementsByTagName("head")[0];
        head.appendChild(script);
      } else {
        this.subject.pipe(filter(function (data) {
          return data.siteKey === siteKey;
        }), timeout(3000)).subscribe({
          next: onload,
          error: function error() {
            console.error("subscribe load recaptcha script timeout");
            onerror();
          }
        });
      }
    }
  }, {
    key: "execute",
    value: function execute(siteKey, action) {
      var grecaptcha = window.grecaptcha;
      if (!grecaptcha) {
        return Promise.reject({
          code: -20,
          message: "grecaptcha not ready"
        });
      }
      return grecaptcha.enterprise.execute(siteKey, {
        action: action
      }).then(function (captcha_token) {
        return {
          captcha_token: captcha_token
        };
      });
    }
  }, {
    key: "getScoreToken",
    value: function getScoreToken(params) {
      var _this3 = this;
      var siteKey = params.siteKey,
        action = params.action;
      if (this.readyKeys.includes(siteKey)) {
        return this.execute(siteKey, action);
      }
      return new Promise(function (resolve) {
        _this3._resolve = resolve;
        _this3.catchError();
        _this3.loadScript(siteKey, params.lang, function () {
          ReCaptchaApi.shared.execute(siteKey, action).then(function (result) {
            resolve(result);
          }).catch(function () {
            resolve(limitedAccessResult);
          });
        }, function () {
          resolve(limitedAccessResult);
        });
      });
    }
  }, {
    key: "render",
    value: function render(container, params) {
      var grecaptcha = window.grecaptcha;
      if (!grecaptcha) {
        return Promise.reject({
          code: -20,
          message: "grecaptcha not ready"
        });
      }
      return new Promise(function (resolve, reject) {
        try {
          var _document$querySelect;
          var theme = (_document$querySelect = document.querySelector("html")) !== null && _document$querySelect !== void 0 && _document$querySelect.className.includes("dark") ? "dark" : "light";
          grecaptcha.enterprise.render(container, {
            theme: theme,
            sitekey: params.siteKey,
            action: params.action,
            callback: function callback(captcha_token) {
              resolve({
                captcha_token: captcha_token
              });
            }
          });
        } catch (error) {
          reject(error);
        }
      });
    }
  }, {
    key: "getWidgetToken",
    value: function getWidgetToken(container, params) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        _this4._resolve = resolve;
        _this4.catchError();
        _this4.loadScript("explicit", params.lang, function () {
          ReCaptchaApi.shared.render(container, params).then(function (result) {
            resolve(result);
          }).catch(function (error) {
            reject(error);
          });
        }, function () {
          resolve(limitedAccessResult);
        });
      });
    }
  }]);
  return ReCaptchaApi;
}();
_defineProperty(ReCaptchaApi, "shared", new ReCaptchaApi());